import { render, staticRenderFns } from "./ConceptModal.vue?vue&type=template&id=0949be0e"
import script from "./ConceptModal.vue?vue&type=script&lang=js"
export * from "./ConceptModal.vue?vue&type=script&lang=js"
import style0 from "./ConceptModal.vue?vue&type=style&index=0&id=0949be0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports